import { render, staticRenderFns } from "./HotelsView.vue?vue&type=template&id=5dfe57c6&"
import script from "./HotelsView.vue?vue&type=script&lang=js&"
export * from "./HotelsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports